import { ButtonStyles, Typography } from '@yiluhub/ui-elements';
import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import clsx from 'clsx';
import React from 'react';

import './styles.scss';

export type StopoverCardProps = {
  heading: string;
  subHeading: string;
  ctaLabel: string;
  buttonLabel: string;
  image: string;
  linkUrl: string;
  handleClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  handleInfoClick?: () => unknown;
  className?: string;
  cornerLogo?: string;
  showLogoBackground?: boolean;
  /**
   * Field to identify the components in the tests
   */
  dataTestId: string;
};

const StopoverCard: React.FC<StopoverCardProps> = ({
  heading,
  subHeading,
  ctaLabel,
  buttonLabel,
  image,
  linkUrl,
  handleClick,
  handleInfoClick,
  className = '',
  dataTestId,
  cornerLogo,
  showLogoBackground,
}) => (
  <div data-testid={dataTestId} className={clsx(className, 'stopover-card_cardContainer')}>
    <div className="stopover-card_outerBox">
      <div
        data-testid={`${dataTestId}-bg-image`}
        className="stopover-card_imageContainer"
        style={{
          backgroundImage: `url(${image})`,
        }}
      />
      {cornerLogo && (
        <div
          className={`stopover-card_floatingLogoContainer ${
            showLogoBackground ? 'stopover-card_floatingLogoContainer--withBg' : ''
          }`}
        >
          <img src={cornerLogo} alt="logo" data-testid={`${dataTestId}-corner-logo`} />
        </div>
      )}
      <div className="stopover-card_contentContainer">
        <div className="stopover-card_upperSection">
          <Typography
            data-testid={`${dataTestId}-heading`}
            variant="h4"
            className="stopover-card_heading"
          >
            {heading}
          </Typography>
          <Typography
            data-testid={`${dataTestId}-subheading`}
            variant="p2"
            className="stopover-card_subheading"
          >
            {subHeading}
          </Typography>
        </div>
        <div className={'stopover-bottomSection'}>
          <ElementsSDK.Link
            Icon={ElementsSDK.Icon.ArrowRight}
            className="stopover-card_ctaLabel"
            href={linkUrl}
            onClick={handleInfoClick}
          >
            {ctaLabel}
          </ElementsSDK.Link>
          <ElementsSDK.Button
            buttonStyle={ButtonStyles.SECONDARY}
            className="stopover-card_button"
            onClick={handleClick}
          >
            {buttonLabel}
          </ElementsSDK.Button>
        </div>
      </div>
    </div>
  </div>
);

export default StopoverCard;
